import { render, staticRenderFns } from "./Mypagedownload.vue?vue&type=template&id=e7c79004&"
import script from "./Mypagedownload.vue?vue&type=script&lang=ts&"
export * from "./Mypagedownload.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports